<template>
  <!-- 添加业绩人弹窗 -->
  <a-modal :visible="visible" :title="achievementTitle" :maskClosable="false" @cancel="handleCancel" :footer="null">
    <!-- ref="ruleForm" -->
    <a-form-model ref="ruleFormAchi" :model="form" :rules="achievementRules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="经纪人" prop="employeeId">
        <div style="display: flex">
          <a-tree-select
            v-model="form.deptId"
            style="width: 140px"
            :dropdown-style="{ maxHeight: '140px', overflow: 'auto' }"
            :tree-data="deptOptions"
            placeholder="请选择部门"
            @change="getDepUserList"
            :replaceFields="replaceFields"
            tree-default-expand-all
          ></a-tree-select>
          -
          <a-select style="width: 100px" v-model="form.employeeId" placeholder="请选择人员">
            <a-select-option v-for="item in userList" :key="item.userId" :value="item.userId">
              {{ item.nickName }}
            </a-select-option>
          </a-select>
        </div>
      </a-form-model-item>
      <!-- 选择房源客源 -->
      <a-form-model-item ref="resourceType" label="来源类型" prop="resourceType">
        <a-radio-group name="radioGroup" v-model="form.resourceType">
          <a-radio value="1">房源</a-radio>
          <a-radio value="2">客源</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item ref="contractRole" label="角色类型" prop="contractRole">
        <a-select v-model="form.contractRole" placeholder="请选择角色类型">
          <a-select-option v-for="item in achievementTypeList" :key="item.dictValue" :value="item.dictValue">
            {{ item.dictLabel }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="业绩分配方式" prop="performanceType">
        <a-radio-group name="performanceType" v-model="form.performanceType">
          <a-radio value="1">百分比</a-radio>
          <a-radio value="2">固定值</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item ref="achievementsRatio" label="分配比例" prop="achievementsRatio" v-if="showAchievementsRatio">
        <a-input
          placeholder="请输入分配比例"
          :maxLength="6"
          type="text"
          v-model="form.achievementsRatio"
          suffix="%"
          @change="floatValidate('achievementsRatio')"
        />
      </a-form-model-item>
      <a-form-model-item ref="achievementsMoney" label="分配业绩" prop="achievementsMoney">
        <!-- <a-input placeholder="请输入分配比例" maxLength="5" type="number" v-model="form.achievementsRatio" suffix="%"/>  @change="floatValidate
        ('achievementsMoney')" -->
        <a-input placeholder="请输入分配业绩金额" type="text" v-model="form.achievementsMoney" />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 10, offset: 10 }">
        <a-button type="primary" style="background: var(--ThemeColor)" @click="onSubmit">确定</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import touristApi from '@/api/system/tourist/tourist';
import { addAchievementsAllotRecord, editAchievementsAllotRecord } from '@/api/system/contract';

export default {
  props: {
    deptList: {
      type: Array,
      default: () => []
    },
    achievementTypeList: {
      type: Array,
      default: () => []
    },
    detailsId: {
      type: [String, Number],
      default: ''
    },
    // 业绩人分配列表
    achievementList: {
      type: Array,
      default: () => []
    },
    // 结单业绩
    commissionSum: {
      type: [String, Number],
      default: ''
    },
    // 详情
    contractsDetails: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    commissionSum: {
      handler(val) {},
      deep: true,
      immediate: true
    },
    deptList: {
      handler(val) {},
      deep: true,
      immediate: true
    },
    contractsDetails: {
      handler(val) {},
      deep: true,
      immediate: true
    },
    achievementList: {
      handler(val) {},
      deep: true,
      immediate: true
    },
    achievementTypeList: {
      handler(val) {},
      deep: true,
      immediate: true
    },
    'form.deptId': {
      handler(newVal, oldVal) {
        if (this.form.deptId) {
          touristApi.getUserList({ deptId: this.form.deptId }).then((res) => {
            const { code, rows } = res;
            if (code === 200) {
              this.userList = rows;
            }
          });
        }
      },
      deep: true
    },
    'form.performanceType': {
      handler(newVal, oldVal) {
        this.form.achievementsMoney = '';
        this.form.achievementsRatio = '';
        if (newVal === '2') {
          this.showAchievementsRatio = false;
        } else {
          this.showAchievementsRatio = true;
        }
        // if (newVal == 2) {
        //   this.form.achievementsMoney = '';
        // } else {
        //   this.form.achievementsRatio = '';
        // }
      }
    }
  },
  data() {
    return {
      // 添加业绩人弹窗
      visible: false,
      achievementTitle: '添加业绩人',
      showAchievementsRatio: true,
      form: {
        contractRole: undefined,
        deptId: undefined,
        achievementsRatio: '',
        deptName: '',
        employeeId: '',
        employeeName: '',
        achievementsMoney: '', // 分配业绩
        resourceType: '',
        performanceType: '1'
      },
      achievementRules: {
        employeeId: [{ required: true, message: '请选择经济人', trigger: 'change' }],
        contractRole: [{ required: true, message: '请选择角色类型', trigger: 'change' }],
        achievementsMoney: [
          { required: true, message: '请输入分配业绩金额', trigger: 'blur' },
          {
            required: true,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,4}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
        ],
        achievementsRatio: [
          { required: true, message: '请输入分配比例', trigger: 'blur' },
          {
            required: true,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,4}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
        ],
        performanceType: [{ required: true, message: '请选择业绩分配方式', trigger: 'change' }]
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      // 部门树选项
      deptOptions: [
        {
          id: 0,
          label: '',
          children: []
        }
      ],
      replaceFields: { children: 'children', title: 'label', key: 'id', value: 'id' },
      userList: []
      // deptList: [], // 部门列表
      // achievementTypeList: [], // 人员业绩类型字典表
    };
  },
  methods: {
    // 添加业绩人弹窗
    // float验证
    floatValidate(fieldName) {
      // achievementsRatio
      const val = this.form[fieldName];
      if (!this.commissionSum) {
        this.$message.error('没有业绩可分配');
        this.form['achievementsRatio'] = 0;
        this.form['achievementsMoney'] = 0;
      }
      const reg = /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/;
      const regs = /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,4}){0,1})$/;
      if (!reg.test(val)) {
        if (fieldName === 'achievementsRatio') {
          this.form[fieldName] = '';
        }
      }
      if (!regs.test(val)) {
        if (fieldName === 'achievementsMoney') {
          this.form[fieldName] = '';
        }
      }
      if (fieldName === 'achievementsRatio') {
        const number = parseFloat(val);
        this.form.achievementsMoney = ((this.commissionSum * number) / 100).toFixed(4);
      }
      // 分配业绩
      if (fieldName === 'achievementsMoney') {
        const number = parseFloat(val);

        this.form.achievementsRatio = ((number / this.commissionSum) * 100).toFixed(4);
      }
    },
    handleCancel() {
      this.visible = false;
    },
    // 人员列表
    getDepUserList(deptId) {
      if (deptId) {
        this.isuser = false;
        this.form.employeeId = undefined;
      } else {
        this.isuser = true;
      }
      touristApi.getUserList({ deptId }).then((res) => {
        const { code, rows } = res;
        if (code === 200) {
          this.userList = rows;
        }
      });
    },
    // 添加编辑业绩人
    onSubmit() {
      // this.$refs.ruleForm.validate((valid) => {
      this.$refs.ruleFormAchi.validate((valid) => {
        if (valid) {
          const achievementList = this.achievementList;
          let achievementsRatioTotal = 0;
          let achiRatio = 0;
          let achievementsMoneyTotal = 0;
          let achieMoney = 0;
          console.log(this.contractsDetails, this.form, this.achievementList, '获取achievementList');
          let list = achievementList.filter((el) => el.achievementsType == '1'); //只取来源为房源的金额
          list = list.filter((el) => el.id !== this.form.id); //不取当前编辑的金额
          for (const achi of list) {
            achiRatio = parseFloat(achi.achievementsRatio);
            achiRatio = achiRatio || 0;

            achieMoney = parseFloat(achi.achievementsMoney);
            achieMoney = achieMoney * 1 || 0;
            achievementsMoneyTotal += achieMoney;
            achievementsRatioTotal += achiRatio;
            console.log(achieMoney, '获取achievementsMoney');
          }

          if (this.form.achievementsRatio >= 100 || achievementsRatioTotal > 100) {
            this.$message.error('分配业绩比例不能超过100%');
            return false;
          }
          console.log(achievementsMoneyTotal, this.form.achievementsMoney, this.commissionSum, '分配金额数据');
          if (
            achievementsMoneyTotal * 1 + this.form.achievementsMoney * 1 > this.commissionSum * 1 ||
            this.form.achievementsMoney * 1 >= this.commissionSum * 1
          ) {
            this.$message.error('分配业绩金额不能超过总业绩金额');
            console.log('分配金额多了');
            return false;
          }

          const { employeeId, deptId } = this.form;
          this.deptList.forEach((item) => {
            if (deptId === item.deptId) {
              this.form.deptName = item.deptName;
            }
          });
          this.userList.forEach((item) => {
            if (employeeId === item.userId) {
              this.form.employeeName = item.nickName;
            }
          });

          const parmars = this.form;
          parmars.contractId = this.detailsId;
          // parmars.resourceType = this.contractsDetails.contractType
          // 修改业绩人
          if (this.form.id) {
            this.getEditAchievementsAllotRecord(parmars);
            return;
          }
          //  新增业绩人
          this.getAddAchievementsAllotRecord(parmars);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getEditAchievementsAllotRecord(parmars) {
      editAchievementsAllotRecord(parmars).then((res) => {
        if (res.code === 200) {
          this.$message.success('修改成功');
          this.visible = false;
          this.$emit('success');
          // this.getAchievementList()
        }
      });
    },
    getAddAchievementsAllotRecord(parmars) {
      addAchievementsAllotRecord(parmars).then((res) => {
        if (res.code === 200) {
          this.$message.success('添加成功');
          this.visible = false;
          this.$emit('success');
          // this.getAchievementList()
        }
      });
    }
  }
};
</script>
<style lang="less" scoped></style>
